import React from 'react'
import Logo from "../../Logo"
import MenuInicioSuscrito from '../../../pages/inicioSuscrito/MenuInicioSuscrito'
import Redes from '../../Redes'
import Footer from '../../Footer'
import "../../../../styles/registrado/noticias/slideNoticias4.css"

function SlideNoticias4() {
  return (
    <>
      <Logo />
      <MenuInicioSuscrito />
      <Redes />
      <div className='body-slideNoticias4'>
        <section className='section-slideNioticias4'>
          <h3 className='subtittle-slideNoticia4'>
          Con la tributaria hubo una reducción en los beneficios de renta laboral exenta y el tope máximo de ingresos no constitutivos de renta
          </h3>
          <p className='paragraph-slideNoticia4'>
            El próximo 19 de octubre terminan los plazos para declarar y pagar el impuesto de renta de 2022. 
            <strong>
              Y si cree que este año le salió caro, expertos tributarios dijeron a La República que el próximo año, 
              cuando tendrá que hacer el pago del año gravable 2023, será más costoso,
            </strong> 
            especialmente por algunas medidas que se aprobaron en la reforma tributaria del año pasado.
          </p>
          <p className='paragraph-slideNoticia4'>
            “Con la reforma tributaria que entró en vigor el 1 de enero de 2023, 
            <strong> 
              las personas naturales verán un incremento en su carga tributaria y un mayor impuesto a pagar en la declaración de renta 
              del año 2023, en comparación con la declaración de renta del año 2022,
            </strong> incluso bajo un escenario en el que sus ingresos no hayan aumentado”, 
            indicó César Cermeño, socio de DLA Piper Martínez Beltrán.
          </p>
          <p className='paragraph-slideNoticia4'>
            El experto argumentó que esto no se debe a modificaciones en las tarifas, 
            <strong>
              sino a una reducción en los beneficios de renta laboral exenta y del límite máximo de rentas exentas y deducciones especiales,
              así como las modificaciones introducidas en la tributación de dividendos.
            </strong>
          </p>
          <p className='paragraph-slideNoticia4'>
            <strong>
              Y es que, con la tributaria, el tope del descuento de 25% al que tienen derecho las personas naturales por rentas laborales 
              ya no será de 2.880 UVT, sino de 790 UVT.
            </strong>
            Mientras que, en cédulas generales, la sumatoria total de la renta exenta de 25% más el total de las deducciones no puede superar
            1.340 UVT, pero ese monto estaba en 5.040 UVT.
          </p>
          <p className='paragraph-slideNoticia4'>
            Explicándolo de forma detallada, Diego Torres, abogado de Tributario en Cuatrecasas y profesor de la Universidad de los Andes, 
            <strong>
              indicó que la renta exenta general se mantuvo en un 25% del valor de los pagos laborales, pero el límite pasó de
              $10 millones mensuales a $2,8 millones.
            </strong>
            “En otras palabras, antes esta limitación afectaba a las personas con ingresos superiores a $40 millones mensuales y, ahora,
            afecta a personas con ingresos a partir de $11,2 millones”, indicó el experto.
          </p>
          <p className='paragraph-slideNoticia4'>
            En cuanto al límite general a las deducciones y rentas exentas, como intereses de vivienda, intereses al Icetex, dependientes,
            4x1.000, contribuciones a fondos de pensiones y cesantías y depósitos en cuentas AFC, Torres dijo que 
            <strong>
              “se mantuvo en 40%, pero su máximo pasó de $17,8 millones mensuales a $4,73 millones.
            </strong>
            De nuevo, este límite antes solo afectaba a personas con ingresos de más de $40 millones y, con la reforma, pasaron a afectar
            a personas con ingresos de $ 11,5 millones”.
          </p>
          <p className='paragraph-slideNoticia4'>
            <strong>
              En esa línea, Iván Aguirre, abogado con maestría en tributación, señaló que, entonces, la reducción de los beneficios 
              afectará a quienes más ganan.
            </strong>
              “Si una persona gana $180 millones al año de salario y su 25% exento era de $45 millones, pues ahora con esa limitación 
              de los 790 UVT no va a tener el mismo beneficio. Entonces esas personas de ingresos más altos son las que van a notar la 
              diferencia sustancial en tributación”.
          </p>
          <p className='paragraph-slideNoticia4'>
            Además de lo anterior, también hubo modificaciones en la tributación de dividendos, según Aguirre. “Un tema importantísimo para
            aquellas personas que son empleadas y, adicionalmente, socias de sus empresas,
            <strong>
              es que las rentas de dividendos también van a ir a la renta líquida cedular general a la que se le aplica la tabla del artículo
              241 del Estatuto Tributario”,
            </strong>
            dijo Aguirre, y agregó que “los ingresos laborales y dividendos se suman para llegar a la base gravable sobre la cual se aplicará 
            una tarifa de hasta 39%”.
          </p>
          <p className='paragraph-slideNoticia4'>
            Cermeño señaló que algunos contribuyentes ya han visto los efectos.
            <strong>
              “Algunos ya han visto los efectos de la reforma en un aumento en la retención en la fuente aplicable,
            </strong>
            pero verán sin duda un mayor efecto al momento de declarar, especialmente aquellos trabajadores con ingresos superiores 
            a los $10 millones”.
          </p>
          <p className='paragraph-slideNoticia4'>
            Ese mismo punto señaló el experto de Cuatrecasas. “Muchos ya han visto este incremento en las retenciones en la fuente mensuales
            que se les han aplicado este año”.
          </p>

          <h3 className='subtittle-slideNoticia4'>
            El recaudo a agosto ha subido 16,4%
          </h3>
          <p className='paragraph-slideNoticia4'>
            La Dian dio a conocer su informe con corte a agosto de este año, en el que da cuenta del balance en recaudo de impuestos. 
            Entre enero y agosto de 2023 se han recaudado $197,2 billones, es decir, hubo un crecimiento real anual de 16,4% frente al 
            mismo periodo de 2022, cuando la suma fue de $169,45 billones. Desagregando por tipo de impuestos, la retención en renta es 
            el que aporta más al total recaudado, con $63,3 billones. Le sigue el impuesto de renta con $47,2 billones y el gravamen a 
            las ventas con $34,2 billones.
          </p>
        </section>
      </div>
      <Footer />
    </>
  )
}

export default SlideNoticias4
